import { firma } from '../content';
import './Impressum.css';

/**
 * Pflichtangaben nach § 5 TMG. Ausschliesslich Daten aus firma - keine
 * zusaetzlichen Fantasie-Angaben. Es gibt keine USt-IdNr., da als
 * Kleinunternehmer keine erteilt wurde; stattdessen Steuernummer und der
 * vorgeschriebene § 19 UStG-Hinweis.
 */
export function Impressum() {
  return (
    <div className="legal-page">
      <div className="container legal-page__inner">
        <h1 className="legal-page__title">Impressum</h1>

        <section className="legal-page__section">
          <h2 className="legal-page__heading">Angaben gemäß § 5 TMG</h2>
          <p>{firma.name}</p>
          <p>Inhaber: {firma.inhaber}</p>
          <p>
            {firma.strasse}
            <br />
            {firma.ort}
          </p>
          <p>Rechtsform: {firma.rechtsform}</p>
        </section>

        <section className="legal-page__section">
          <h2 className="legal-page__heading">Kontakt</h2>
          <p>Telefon: {firma.telefon}</p>
          <p>
            E-Mail: <a href={`mailto:${firma.mailAllgemein}`}>{firma.mailAllgemein}</a>
          </p>
        </section>

        <section className="legal-page__section">
          <h2 className="legal-page__heading">Steuerliche Angaben</h2>
          <p>Steuernummer: {firma.steuernummer}</p>
          <p>Kleinunternehmer gemäß § 19 UStG — es wird keine Umsatzsteuer ausgewiesen.</p>
        </section>

        <section className="legal-page__section">
          <h2 className="legal-page__heading">Verantwortlich für den Inhalt</h2>
          <p>
            {firma.inhaber}, Anschrift wie oben ({firma.strasse}, {firma.ort}).
          </p>
        </section>
      </div>
    </div>
  );
}
